// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoPlayer_container__2poM7","icon-play":"VideoPlayer_icon-play__U8HDP","video-player-title":"VideoPlayer_video-player-title__2eMx-"};